<div
  (click)="selectedDate($event)"
  class="day-picker-window"
  [ngClass]="daysClasses"
>
  <p class="capitalize text-xs font-extrabold">{{ day_name }}</p>
  <p>{{ day_number }}</p>
</div>
